import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SecondaryNavigation from '../common/navigation/secondary-navigation';
import LiveBlog from './live-blog-v2';
import { Broadcast } from '../../../features/broadcast/Broadcast';
import SocialKit from './social-kit';
import SocialReviews from './social-reviews';
import Reactions from './reactions';
import CommunitySpotlight from './community-spotlight';
import FloatingBell from './floating-bell/FloatingBell';
import TopicTracker from './topic-tracker/TopicTracker';
import { getSpotlightTabConfig } from './api/get-config';
import { withAuth } from 'app/scripts/components/common/auth-checker/with-auth';

const displayName = 'Integrations';

class Integrations extends Component {
  state = {
    configFromDb: {}
  };

  componentDidMount() {
    const { spot } = this.props;
    getSpotlightTabConfig(spot.id).then(res => {
      this.setState({ configFromDb: res });
    });
  }

  render() {
    var { spot, currentRoute } = this.props;
    var spotId = spot.id;
    var sort = (currentRoute && currentRoute.params.sort) || 'newest';
    var components = [];
    var secondaryMenuItems = [];
    secondaryMenuItems.push({
      label: 'Social Kit',
      routeName: 'features-conversation',
      navParams: { spot_id: spotId }
    });
    secondaryMenuItems.push({
      label: 'Spotlight',
      routeName: 'features-spotlight',
      navParams: { spot_id: spotId }
    });
    secondaryMenuItems.push({
      label: 'Social Reviews',
      routeName: 'features-social',
      navParams: { spot_id: spotId }
    });
    secondaryMenuItems.push({
      label: 'Broadcast',
      routeName: 'features-broadcast',
      navParams: { spot_id: spotId }
    });

    secondaryMenuItems.push({
      label: 'Live Blog',
      routeName: 'features-live-blog',
      navParams: { sort, spot_id: spotId }
    });

    secondaryMenuItems.push({
      label: 'Reactions',
      routeName: 'features-reactions',
      navParams: { spot_id: spotId }
    });

    secondaryMenuItems.push({
      label: 'Topic Tracker',
      routeName: 'features-topic-tracker',
      navParams: { spot_id: spotId }
    });

    secondaryMenuItems.push({
      label: 'Floating Bell',
      routeName: 'features-floating-bell',
      navParams: { spot_id: spotId }
    });

    components.push(
      <SecondaryNavigation
        key="1"
        title="Features"
        selected={currentRoute.page}
        menuItems={secondaryMenuItems}
      />
    );
    switch (currentRoute.page) {
      case 'features-conversation':
        components.push(<SocialKit key="2" platform={spot.platform} spotId={spotId} />);
        break;
      case 'features-social':
        components.push(<SocialReviews key="3" platform={spot.platform} spotId={spotId} />);
        break;
      case 'features-broadcast':
        components.push(<Broadcast key="5" spotId={spotId} />);
        break;
      case 'features-live-blog':
        components.push(<LiveBlog />);
        break;
      case 'features-reactions':
        components.push(<Reactions key="7" spotId={spotId} />);
        break;
      case 'features-spotlight':
        components.push(<CommunitySpotlight key="8" spot={spot} />);
        break;

      case 'features-floating-bell':
        components.push(<FloatingBell key="10" />);
        break;
      case 'features-topic-tracker':
        components.push(<TopicTracker key="10" />);
        break;
    }

    return <div className="preferences">{components}</div>;
  }
}

Integrations.propTypes = {
  currentRoute: PropTypes.object.isRequired,
  spot: PropTypes.object
};

Integrations.displayName = displayName;

export default withAuth(Integrations);
